import { loader } from 'graphql.macro'
export const getAccountTokens = loader('./getAccountTokens.graphql').loc.source.body
